import { render, staticRenderFns } from "./AdminForumPost.vue?vue&type=template&id=09559b44&"
import script from "./AdminForumPost.vue?vue&type=script&lang=js&"
export * from "./AdminForumPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports